
import { PackageData } from "@/pages/CreatePackage";
import { TemplateStyle } from "../types";
import { companyName } from "../constants";
import { generateQrCode } from "../helpers";
import { renderCommonSection } from "../commonSections";

const renderSection = (sectionId: string, packageData: PackageData): string => {
  const common = renderCommonSection(sectionId, packageData);
  if (common !== null) return common;

  switch (sectionId) {
    case 'client': {
        const clientCompanyLogoHtml = packageData.companyLogoUrl ? `<img src="${packageData.companyLogoUrl}" alt="شعار شركة العميل" style="max-height: 40px; margin-bottom: 10px; border-radius: 4px;" />` : '';
        const companyNameHtml = packageData.companyName ? `<div class="item"><strong>الشركة:</strong> ${packageData.companyName}</div>` : '';
        return `<div class="section">
                    <h3>معلومات العميل</h3>
                    ${clientCompanyLogoHtml}
                    ${companyNameHtml}
                    <div class="item"><strong>جهة الاتصال:</strong> ${packageData.clientName}</div>
                    <div class="item"><strong>البريد الإلكتروني:</strong> ${packageData.clientEmail}</div>
                </div>`;
    }
    case 'hotels':
      if (packageData.hotels.length === 0) return '';
      return `<div class="section"><h3>الإقامة الفندقية</h3>${packageData.hotels.map(hotel => `<div class="item"><strong>${hotel.name}</strong> - ${hotel.nights} ليالي</div>`).join('')}</div>`;
    case 'flights':
      if (packageData.flights.length === 0) return '';
      return `<div class="section"><h3>رحلات الطيران</h3>${packageData.flights.map(flight => `<div class="item"><strong>${flight.airline}</strong>: ${flight.from} - ${flight.to}</div>`).join('')}</div>`;
    case 'tours':
      if (packageData.tours.length === 0) return '';
      return `<div class="section"><h3>الجولات</h3>${packageData.tours.map(tour => `<div class="item"><strong>${tour.name}</strong><br>${tour.description}</div>`).join('')}</div>`;
    case 'price':
      return `<div class="price-box"><div class="total">$${packageData.totalPrice}</div></div>`;
    default:
      return '';
  }
};

export const getTemplate6HTML = async (packageData: PackageData, settings: TemplateStyle): Promise<string> => {
  const columnsHtml = settings.columns.map(column => {
    const sectionsHtml = column.sections.map(section => renderSection(section.id, packageData)).join('');
    return `<div class="pdf-column">${sectionsHtml}</div>`;
  }).join('');

  const qrCodeData = await generateQrCode(`Package: ${packageData.packageName}\nClient: ${packageData.clientName}\nPrice: $${packageData.totalPrice}`);
  
  const logoHtml = settings.media?.logo ? `<img src="${settings.media.logo}" alt="Company Logo" style="max-height: 60px; margin-bottom: 15px;" />` : '';
  const backgroundStyle = settings.media?.background ? `background: url('${settings.media.background}') center center / cover no-repeat;` : '';

  return `
    <!DOCTYPE html>
    <html dir="rtl" lang="ar">
    <head>
      <meta charset="UTF-8">
      <title>عرض سياحي - ${packageData.packageName}</title>
      <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Arabic:wght@400;700&display=swap" rel="stylesheet">
      <style>
        body { font-family: 'IBM Plex Sans Arabic', sans-serif; background-color: #e5e7eb; color: ${settings.colors.text}; }
        .container { max-width: 800px; margin: 20px auto; background: #fff; border-radius: 12px; overflow: hidden; ${backgroundStyle} }
        .header { padding: 30px; background-color: ${settings.colors.primary}; color: white; text-align: center; }
        .header h1 { font-size: 28px; margin: 0; }
        .header p { opacity: 0.9; }
        .content { padding: 30px; background-color: ${settings.colors.background}; }
        .pdf-row { display: flex; flex-direction: row; gap: 20px; }
        .pdf-column { flex: 1; min-width: 0; }
        .section { margin-bottom: 20px; }
        .section h3 { font-size: 18px; color: ${settings.colors.primary}; margin-bottom: 10px; font-weight: 700; }
        .item { padding: 15px; background: #fff; border-radius: 8px; margin-bottom: 10px; border: 1px solid #d1d5db; }
        .price-box { padding: 20px; text-align: right; }
        .price-box .total { font-size: 30px; font-weight: 700; color: ${settings.colors.primary}; }
        .footer { text-align: center; color: #6b7280; padding: 20px; font-size: 12px; background-color: #fff; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          ${logoHtml}
          <h1>${packageData.packageName || 'عرض التقنية المتقدمة'}</h1>
          <p>${packageData.destination} / ${packageData.duration}</p>
        </div>
        <div class="content">
          <div class="pdf-row">
            ${columnsHtml}
          </div>
          <div class="footer">
            <img src="${qrCodeData}" alt="QR Code" style="width:70px;height:70px;margin:10px auto;" />
            ${companyName}
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};
